<template>
  <a
    :href="get_src"
    class="gallery__item"
    target="_blank"
    :data-pswp-width="width"
    :data-pswp-height="height"
    rel="noreferrer">
    <lazy-image
      cover_img
      :src="image_src"
      :lazy_src="image_src_lazy"
    />
  </a>
</template>

<script>
import LazyImage from "../../small_parts/LazyImage.vue";

export default {
  name: 'GalleryItem',
  components: {LazyImage},
  props: {
    image_src: {
      required: true,
      type: String,
    },
    image_src_lazy: {
      type: String,
      default: ''
    },
    gallery_src: {
      type: String,
      default: ''
    },
  },
  computed: {
    get_src() {
      return this.gallery_src || this.image_src_lazy || this.image_src
    }
  },
  data() {
    return {
      width: 0,
      height: 0
    }
  },
  methods: {
    calculateSize() {
      let img = new Image()
      img.src = this.get_src;
      img.onload = () => {
        this.height = img.naturalHeight
        this.width = img.naturalWidth
      }
    }
  }
}
</script>
